import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "../../../../redux/store";
import SVGCross from "components/_common/icons/tool/SVGCross";

type OwnProps = {
	onClose: () => void;
};
type ConsumptionGuidelinesModalProps = PropsFromRedux & OwnProps;
function ConsumptionGuidelinesModal(props: ConsumptionGuidelinesModalProps) {
	const { onClose } = props;
	return (
		<div className="flex justify-center items-center rounded  bg-white w-full h-[calc(100vh-200px)] relative">
			<div
				onClick={() => onClose()}
				className="absolute right-0 top-0 m-6 w-4 h-4 cursor-pointer"
			>
				<SVGCross />
			</div>
			<div className="p-6 pt-4 w-full h-full">
				<div className="mb-2">
					<h3 className="text-xl font-medium">Consumption Guidelines</h3>
					<a
						href={
							"https://onlineprescribing.com/wp-content/uploads/2025/04/Ships-Controlled-Drug_Register.pdf"
						}
						className="text-blue-500 text-sm font-medium"
						rel="noreferrer"
						target="_blank"
					>
						Download pdf
					</a>
				</div>
				<iframe
					className="rounded"
					src={
						"https://onlineprescribing.com/wp-content/uploads/2025/04/Ships-Controlled-Drug_Register.pdf"
					}
					title="Consumption Guidelines"
					width={"100%"}
					height={"90%"}
				/>
			</div>
		</div>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(ConsumptionGuidelinesModal);
